import { computed } from "vue";
import { useRoute } from "vue-router";

// Chemins de chaque page dans les deux langues
export const PATHS = {
  home: { fr: "/", en: "/en" },
  about: { fr: "/about", en: "/en/about" },
  experience: { fr: "/parcours", en: "/en/experience" },
  projects: { fr: "/projects", en: "/en/projects" },
  community: { fr: "/community", en: "/en/community" },
};

export const MENU = [
  { key: "about", label: { fr: "À propos", en: "About" } },
  { key: "experience", label: { fr: "Parcours", en: "Experience" } },
  { key: "projects", label: { fr: "Projets", en: "Projects" } },
  { key: "community", label: { fr: "Community & Talks", en: "Community & Talks" } },
];

export function translate(value, lang, en) {
  if (en !== undefined) return lang === "en" ? en : value;
  if (value && typeof value === "object" && "fr" in value) return lang === "en" && value.en != null ? value.en : value.fr;
  return value;
}

export function useI18n() {
  const route = useRoute();
  const lang = computed(() => route.meta.lang || "fr");
  const t = (value, en) => translate(value, lang.value, en);
  const to = (key) => PATHS[key][lang.value];
  const otherLangPath = computed(() => {
    const key = route.meta.key;
    const other = lang.value === "en" ? "fr" : "en";
    return key ? PATHS[key][other] : PATHS.home[other];
  });
  return { lang, t, to, otherLangPath };
}
